app.controller("ApartmentMapController",
	["$scope", "$http", "$q", function($scope, $http, $q) {
		var panorama;
		var streetViewService = new google.maps.StreetViewService();
		$scope.map_view = 'map';
		$scope.street_view_available = false;
		$scope.map = undefined;
		$scope.approximateAddress = undefined;
		$scope.bounds = undefined;


		$scope.initialize = function() {

			var deferred = $q.defer();
			var promise = deferred.promise;

			if($scope.approximateAddress !== undefined) {
				promise = $scope.resolveAddress($scope.approximateAddress).then(function(response) {
					if(response.data.results.length > 0) {
						var result = response.data.results[0];

						//$scope.zoomToBoundsAndSetMarker(result.geometry.bounds.northeast,
						//	result.geometry.bounds.southwest, result.geometry.location);
						$scope.latitude = result.geometry.location.lat;
						$scope.longitude = result.geometry.location.lng;


						if(result.geometry.bounds === undefined) {
							if(result.geometry.viewport !== undefined) {
								$scope.bounds = new google.maps.LatLngBounds();
								$scope.bounds.extend(new google.maps.LatLng(result.geometry.viewport.northeast.lat, result.geometry.viewport.northeast.lng));
								$scope.bounds.extend(new google.maps.LatLng(result.geometry.viewport.southwest.lat, result.geometry.viewport.southwest.lng));
							}
						}
						else {
							$scope.bounds = new google.maps.LatLngBounds();
							$scope.bounds.extend(new google.maps.LatLng(result.geometry.bounds.northeast.lat, result.geometry.bounds.northeast.lng));
							$scope.bounds.extend(new google.maps.LatLng(result.geometry.bounds.southwest.lat, result.geometry.bounds.southwest.lng));
						}
					}
					else {
						deferred.resolve();
					}
				});
			}
			else {
				deferred.resolve();
			}

			promise.then(function(result) {
				var myLatlng = new google.maps.LatLng($scope.latitude,$scope.longitude);
				var mapOptions = {
					zoom: 15,
					center: myLatlng,
					scrollwheel: false
				};
				var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

				var marker = new google.maps.Marker({
					position: myLatlng,
					map: map
				});

				if($scope.bounds !== undefined) {
					map.fitBounds($scope.bounds);
				}

				streetViewService.getPanoramaByLocation(myLatlng, 50, function (streetViewPanoramaData, status) {
					if (status === google.maps.StreetViewStatus.OK) {
						panorama = map.getStreetView();
						panorama.setPosition(myLatlng);
						panorama.setOptions({enableCloseButton: false});
						$scope.$apply(function() {
							$scope.street_view_available = true;
						});
					}
				});
			}, function(result) {

			});

		};


		$scope.setApproximateAddress = function(addressString) {
			$scope.approximateAddress = addressString;
		};


		$scope.resolveAddress = function(addressString) {
			// https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=API_KEY
			return $http({
				method: 'GET',
				url: 'https://maps.googleapis.com/maps/api/geocode/json',
				params: {
					address: addressString
				}
			});
		};

		$scope.showMap = function() {
			panorama.setVisible(false);
			$scope.map_view = 'map';
		};

		$scope.showStreetView = function() {
			panorama.setVisible(true);
			$scope.map_view = 'streetview';
		};

		google.maps.event.addDomListener(window, 'load', $scope.initialize);
	}]
);